import React, { PureComponent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import i18n from '../../i18n';
import './SavingMessage.css';

// Saving Message to ensure user knows a save is ongoing
class SavingMessage extends PureComponent {

    static defaultProps = {
        saveInProgress: 0,
        saveFailed: false,
        saveColor: '#05A9B1',
    };

    render() {

        const {
            saveInProgress,
            saveFailed,
            saveColor,
          } = this.props;
          
        return (
            saveInProgress > 0 ? 
            <div className='saving-message'>
                {saveFailed ?
                    <div className='save-failed'>
                        {i18n.t('save-failed')}
                    </div>
                : null }
                <div className='saving-icon'>
                    <FontAwesomeIcon icon="circle-notch" size="3x" style={{ color: saveColor }} spin />
                </div>
            </div>
            : null
        );
    }
}

export default SavingMessage;
